import Vue from 'vue';

// todo, create file: https://medium.com/a-beginners-guide-for-webpack-2/extract-text-plugin-668e7cd5f551

import './css/App.scss';
import routes from './routes';
import VueSimpleAlert from "vue-simple-alert";
import './registerServiceWorker'
import OnoffToggle from 'vue-onoff-toggle'
import TimePicker from './components/Utils/TimePicker';
import TableNumbers from './components/TableNumbers';
import tagManager from './components/Utils/TagManager.js';

import configRepository from './repositories/ConfigRepository';
Vue.prototype.$configRepository = configRepository;

import signalR from './repositories/signalR';
Vue.prototype.$signalR = signalR;


// require('bootstrap');

Vue.config.productionTip = true;


let options = {
	//weekday: "long", year: "numeric", month: "short",
	//day: "numeric",
	hour: "2-digit", minute: "2-digit"
};

let dayTimeOptions = {
	weekday: "long", 
	hour: "2-digit", minute: "2-digit"
};

Vue.filter('formatTime', function (value, showSeconds) {

	if (value == null) {
		return '';
	}

	if (showSeconds) {
		return value.toLocaleTimeString("nl-nl");
	}

	if (typeof value.toLocaleTimeString == 'function' )
		return value.toLocaleTimeString("nl-nl", options);

	return '';
});

Vue.filter('formatDayTime', function (value) {

	if (value == null) {
		return '';
	}

	return value.toLocaleTimeString("nl-nl", dayTimeOptions);
});


Vue.use(VueSimpleAlert);
Vue.use(OnoffToggle);
Vue.component('TimePicker', TimePicker);
Vue.component('TableNumbers', TableNumbers);


const app = new Vue({

	data: {
		currentRoute: window.location.hash
	},
	
	computed: {
		ViewComponent() {
			const matchingView = routes[this.currentRoute];

			console.log(matchingView);
			return matchingView
				? require('./views/' + matchingView + '.vue')
				: require('./views/404.vue')
		}
	},

	render(h) {	
		var app = this.ViewComponent;
		return h(app.default)
	},
	components: {
		TimePicker,
	}

}).$mount('#app');


Vue.use(tagManager)

window.addEventListener('popstate', () => {
	app.currentRoute = window.location.hash
})